var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","viewBox":"0 0 18 18","fill":"none","aria-hidden":"true"}},[_c('path',{attrs:{"d":"M14.625 6.75L9 12.375L3.375 6.75","stroke":"currentColor","stroke-width":"1.6875","stroke-linecap":"round","stroke-linejoin":"round"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }